// Structured trace of the claiming protocol, for the verification harness in
// UPLOAD_TESTER and for debugging a live event.
//
// Off unless the page is opened with ?modlog=1, so it costs nothing normally.
// One line per event, JSON after a fixed prefix, because the harness reads it
// off the console of several browsers at once and merges them into a single
// timeline — which is the only way to tell a legitimate takeover from two
// moderators holding the same video.

let enabled = false
try {
  enabled = new URLSearchParams(window.location.search).get('modlog') === '1'
} catch {
  /* no window (SSR / tests): stay off */
}

export const modlogEnabled = enabled

export function modlog(event, data) {
  if (!enabled) return
  console.log('[MODLOG]', JSON.stringify({ t: Date.now(), event, ...data }))
}
